mutation deactivateConnection {
    konstantine {
        deactivateConnection {
            id
            companyId
            status
        }
    }
}
